import InputBase from "@mui/material/InputBase";
import styled from "styled-components";
// import styled from '@emotion/styled'
const StyledInput = styled.div`
  .MuiFormControl-root {
    width: 100%;
  }
  label {
    font-size: 16px;
    line-height: 24px;
    font-family: inherit;
    transform: none;
    color: inherit;
  }
  input {
    border: 0.8px solid #979797;
    border-radius: 4px;
    min-height: 48px;
    margin-top: 31px;
    padding: 12px;
    font-family: inherit;
    font-size: 16px;
    line-height: 24px;
    color: inherit;
    ::-webkit-input-placeholder {
      color: #787874;
    }

    :-ms-input-placeholder {
      color: #787874;
    }

    ::placeholder {
      color: #787874;
    }
  }
`;

// const StyledInput = styled(InputBase)(() => ({

//     'label' : {
//         color: 'red',
//     },
//     'label + &': {
//       marginTop: '31px',
//     },
//     '& .MuiInputBase-input': {
//       borderRadius: 4,
//       position: 'relative',
//     //   backgroundColor: theme.palette.mode === 'light' ? '#fcfcfb' : '#2b2b2b',
//       border: '1px solid #ced4da',
//       fontSize: 16,
//       width: '100%',
//       padding: '10px 12px',
//     //   transition: theme.transitions.create([
//     //     'border-color',
//     //     'background-color',
//     //     'box-shadow',
//     //   ]),
//       fontFamily: [
//         '-apple-system',
//         'BlinkMacSystemFont',
//         '"Segoe UI"',
//         'Roboto',
//         '"Helvetica Neue"',
//         'Arial',
//         'sans-serif',
//         '"Apple Color Emoji"',
//         '"Segoe UI Emoji"',
//         '"Segoe UI Symbol"',
//       ].join(','),
//       '&:focus': {
//         // boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
//         // borderColor: theme.palette.primary.main,
//       },
//     },
//   }));

export { StyledInput };
